import React from "react";
import moment from "moment";
import {Link, useNavigate, useLocation} from "react-router-dom";

import Tag from "../tag/Tag";
import {useLazyGetArticlesQuery} from "../../api/blog";

import styles from './OtherArticles.module.scss';

type ArticleCategory = {
    id: string | number;
    name: string;
    slug: string;
};

type Article = {
    id: string | number;
    slug: string;
    createdAt: string;
    title: string;
    categories?: ArticleCategory[];
};

type OtherArticlesProps = {
    articles?: Article[];
    tags?: ArticleCategory[];
    value?: string;
};

function OtherArticles({articles = [], value}: OtherArticlesProps) {

    const [ articlesRequest ] = useLazyGetArticlesQuery()

    const navigate = useNavigate();
    const location = useLocation();

    const onClickTag = (event: React.MouseEvent<HTMLDivElement>, slug: string) => {
        event.preventDefault();

        if (location.pathname !== '/blog') {
            navigate('/blog', {
                state: { category: slug }
            });
        } else {
            articlesRequest({ category: slug });
        }

    }

    return <>
        {value && <h2 className={styles.subtitle}>
            Результаты поиска
        </h2>}
            {value && !articles.length && <h3 className={styles.titleArticle}>
                Ничего не найдено
            </h3>}
            {
                articles?.map(article => (
                    <Link to={`/blog/${article.slug}`} className={styles.article} key={article.id}>
                        <h3 className={styles.date}>{moment(article.createdAt).format('DD MMMM YYYY')}</h3>
                        <h2 className={styles.titleArticle}>{article.title}</h2>
                        <div className={styles.tags}>
                            {article.categories && article.categories.map(category => (
                                <Tag
                                    slug={category.slug}
                                    onClick={(e) => onClickTag(e, category.slug)}
                                    key={category.id}
                                >{category.name}</Tag>
                            ))}
                        </div>
                    </Link>
                ))
            }
        </>

}

export default OtherArticles;
